import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { UserSession } from '../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { NprLookup } from '../../service/api-service';
import S3ImagePreview from '../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../assets/placeholder';
import MultiDropdownApi from '../../components/MultiDropdownApi';
import ImageS3Upload from '../../components/ImageS3Upload';
import { v4 as uuid } from 'uuid';
import { addEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import IntervalDropdown from '../../components/IntervalDropdown';
import { add, update } from '../../service/equipmentListService';
import { addRiskJobTask, addSiteRiskJobTask, updateRiskJobTask } from '../../service/riskAssessmentService';
import TypeTableSelectApi from '../../components/TypeTableSelectApi';
import { GenericTableColumTypes, GenericTableFilterTypes } from '../../enum/TableView';
import { GenericTableColumns } from '../../models/GenericTableViewModel';

export default function RiskJobTaskSiteAdd(modalProps: any) {

  const details = modalProps?.details;

  async function Add() {
    let updateDetails: any = {
      job_task: jobTask.map((task: any) => task.id),
    };
    modalProps.setGlobalLoading(true);
    addSiteRiskJobTask(updateDetails).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Risk Task Added Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Add Risk Task', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
  }

  const jobTaskColumns: GenericTableColumns[] = [
      {
        field: 'task_id',
        header: 'Task ID',
        type: GenericTableColumTypes.Text,
        visible: true,
        sort: true,
        filter: true,
        filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [{
            label: '',
            value: ''
          }]
        }
      },
      {
        field: 'name',
        header: 'Name',
        type: GenericTableColumTypes.Text,
        visible: true,
        sort: false,
        filter: true,
        filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [{
            label: '',
            value: ''
          }]
        }
      },
      {
        field: 'description',
        header: 'Description',
        type: GenericTableColumTypes.Text,
        visible: true,
        sort: false,
        filter: true,
        filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [{
            label: '',
            value: ''
          }]
        }
      },
      {
        field: 'category_list',
        header: 'Scope Based Task Categories',
        type: GenericTableColumTypes.Text,
        visible: true,
        sort: false,
        filter: true,
        filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [{
            label: '',
            value: ''
          }]
        }
      },
      {
        field: 'safe_work_method_name',
        header: 'Safe Work Method',
        type: GenericTableColumTypes.Text,
        visible: true,
        sort: false,
        filter: true,
        filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [{
            label: '',
            value: ''
          }]
        }
      }
    ];

    const [jobTask, setJobTask] = React.useState<any>(details?.jobTask || []);

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <TypeTableSelectApi
          key={"job-task"}
          label="Job Tasks"
          optionLabel="name"
          optionValue="id"
          typePath="risk-task-category"
          typeKey="category_list"
          columns={jobTaskColumns}
          apiPath="risk-job-task"
          selectedData={jobTask}
          setSelectedData={setJobTask}
          selectionMode="multiple"
        />
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}